<template lang="pug">
    section#banner
        div.fundo
            img(:src="require('@images/backgrounds/fundo-noticias.jpg')", alt="")
        div.texto
            h1 Notícias UniFAEL
            p As principais notícias da UniFAEL a um clique de você.
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
